import React, { useContext } from "react";
import { HotelContext } from "../../../context/HotelContext";
import { getLocale, translate } from "../../../utils/Translation";
import LoadingIndicator from "./LoadingIndicator";
import "./SummaryStatCard.css";

export const formatSummaryStatDelta = (value, unit = "", locale = "fr-FR") => {
  if (value === null || value === undefined) return "—";
  const n = Number(value) || 0;
  const sign = n >= 0 ? "+" : "-";
  const abs = Math.round(Math.abs(n)).toLocaleString(locale);
  return `${sign} ${abs}${unit}`;
};

const SummaryStatCard = ({
  title,
  subtitle,
  value,
  valueUnit = "",
  deltaValue,
  accentColor = "#3C5544",
  footerText,
  hideDelta = false,
  loading = false,
  hide = false,
  className = "",
}) => {
  const { lang } = useContext(HotelContext);
  const locale = getLocale(lang);
  const resolvedSubtitle = subtitle ?? translate("since_beginning", lang);
  const lastMonthLabel = translate("v2_last_month", lang);

  if (hide) return null;

  const cardClassName = ["summary-stat-card", className].filter(Boolean).join(" ");

  if (loading) {
    return (
      <div className={cardClassName}>
        <div className="summary-stat-card__header">
          {title ? <div className="summary-stat-card__title">{title}</div> : null}
          {resolvedSubtitle ? <div className="summary-stat-card__subtitle">{resolvedSubtitle}</div> : null}
        </div>
        <div className="summary-stat-card__loading">
          <LoadingIndicator />
        </div>
      </div>
    );
  }

  const normalizedValue = value === null || value === undefined ? "—" : value;
  const normalizedDelta = deltaValue === null || deltaValue === undefined ? "—" : deltaValue;

  return (
    <div className={cardClassName}>
      <div className="summary-stat-card__header">
        {title ? <div className="summary-stat-card__title">{title}</div> : null}
        {resolvedSubtitle ? <div className="summary-stat-card__subtitle">{resolvedSubtitle}</div> : null}
      </div>

      <div className="summary-stat-card__value" style={{ color: accentColor }}>
        {normalizedValue}
        {!!valueUnit && <span className="summary-stat-card__unit">{valueUnit}</span>}
      </div>

      {footerText ? (
        <p className="summary-stat-card__footer">{footerText}</p>
      ) : hideDelta ? null : (
        <div className="summary-stat-card__delta-row">
          <span className="summary-stat-card__delta-pill" style={{ backgroundColor: accentColor }}>
            {normalizedDelta}
          </span>
          <span className="summary-stat-card__delta-label">{lastMonthLabel}</span>
        </div>
      )}
    </div>
  );
};

export const SummaryStatCardsRow = ({ cards = [], className = "" }) => {
  const rowClassName = ["summary-stat-cards-row", className].filter(Boolean).join(" ");

  return (
    <div className={rowClassName}>
      {cards.map((card) => (
        <SummaryStatCard
          key={card.id}
          title={card.title}
          subtitle={card.subtitle}
          value={card.value}
          valueUnit={card.valueUnit}
          deltaValue={card.deltaValue}
          accentColor={card.accentColor}
          footerText={card.footerText}
          hideDelta={card.hideDelta}
          loading={card.loading}
          hide={card.hide}
        />
      ))}
    </div>
  );
};

export default SummaryStatCard;
